"use client";

import type { ReactNode } from "react";
import { Menu } from "lucide-react";

import { AppSidebar } from "@/components/app-sidebar";
import { Button } from "@/components/ui/button";
import { SidebarInset, SidebarProvider, useSidebar } from "@/components/ui/sidebar";

export type BreadcrumbEntry = {
  label: string;
  href?: string;
};

export function CarehubShell({
  breadcrumbs: _breadcrumbs,
  title,
  actions,
  children,
}: {
  breadcrumbs: BreadcrumbEntry[];
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  void _breadcrumbs;

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="relative min-h-[100dvh] overflow-y-auto lg:h-[100dvh] lg:overflow-hidden lg:overscroll-contain">
        <div className="flex min-h-0 flex-1 flex-col gap-4 px-6 pb-6 pt-[26px] lg:overflow-hidden">
          {title || actions ? (
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <MobileSidebarToggle />
                {title ? <h1 className="text-2xl font-semibold tracking-tight">{title}</h1> : null}
              </div>
              {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
            </div>
          ) : (
            <MobileSidebarToggle />
          )}
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

function MobileSidebarToggle() {
  const { toggleSidebar, isMobile } = useSidebar();

  if (!isMobile) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-9 w-9 lg:hidden"
      onClick={toggleSidebar}
      aria-label="Open navigation"
    >
      <Menu className="h-5 w-5" aria-hidden="true" />
    </Button>
  );
}
